module.exports = __webpack_public_path__ + "static/media/img_onboarding_header_bg_mobile_group4.535647c7.png";